import Vue from "vue";
import Vuex from "vuex";
import Toasted from "vue-toasted";
import * as auth from "./modules/auth";
import * as course from "./modules/course";
import * as levelStats from "./modules/levelStats";
import * as dashboardCache from "./modules/dashboardCache";
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Vuex);
Vue.use(Toasted);
Vue.use(VueLoading);

export default new Vuex.Store({
  state: {
    previousRoute: null,
  },
  mutations: {
    SET_PREVIOUS_ROUTE(state, route) {
      state.previousRoute = route;
    },
  },
  actions: {},
  modules: {
    auth,
    course,
    levelStats,
    dashboardCache,
  },
});
